import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  getWidgetsFromReducer,
  getUserDetailsFromReducer,
  setWidgets,
  addWidget,
  editWidget,
  deleteWidget,
  updateUserDetailsInReducer,
} from "Store/reducers/Auth/AuthSlice";
import { generateUUID } from "Utility/Common/Methods";
import { updateAccountDetails } from "Sdk/Actions";
import { WidgetRenderer } from "./WidgetRenderer";
import { message } from "antd";

function Widgets() {
  const widgets = useSelector(getWidgetsFromReducer);
  const userDetails = useSelector(getUserDetailsFromReducer);
  const dispatch = useDispatch();
  const [uuid1, setuuid1] = useState();
  const [uuid2, setuuid2] = useState();

  useEffect(() => {
    let widget = userDetails?.widgets;
    if (widget && widget?.length > 0) {
      try {
        let data = JSON.parse(widget);
        dispatch(setWidgets(data));
      } catch (error) {
        console.log(error);
      }
    } else {
      dispatch(setWidgets([]));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userDetails]);

  useEffect(() => {
    setTimeout(() => {
      setuuid2(uuid1);
    }, 3000);
  }, [uuid1]);

  useEffect(() => {
    if (uuid2) handleSaveWidgets();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uuid2]);

  const handleEditWidget = ({ index, key, value }) => {
    dispatch(editWidget({ index, key, value }));
    setuuid1(generateUUID());
  };

  const handleDeleteWidget = (index) => {
    dispatch(deleteWidget(index));
    setuuid1(generateUUID());
  };

  const handleSaveWidgets = async () => {
    if (uuid1 !== uuid2) {
      return;
    }
    try {
      let data = widgets.map(({ isEditing, ...rest }) => rest);
      let widgetStringified = JSON.stringify(data);
      const userData = {
        username: userDetails?.username,
        widgets: widgetStringified,
      };
      await updateAccountDetails(userData);
      dispatch(updateUserDetailsInReducer({ widgets: widgetStringified }));
      message.success("Changes saved! Publish to go live.");
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="flex flex-col w-full">
      <WidgetRenderer
        username={userDetails?.username}
        widgets={widgets}
        onWidgetEdit={handleEditWidget}
        onWidgetDelete={handleDeleteWidget}
      />
    </div>
  );
}

export default Widgets;
